import React from 'react';
import PropTypes from 'prop-types';

import contractPage from 'hoc/contractPage/contractPage';

import ContractTemplate from '../patterns/ContractTemplate/ContractTemplate';

export function RewardsRegulation({ pageContent }) {
  return (
    <ContractTemplate title={'Regulamento ao Programa de Recompensas e Benefícios ("Regulamento")'}>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: pageContent }} />
    </ContractTemplate>
  );
}

RewardsRegulation.propTypes = {
  pageContent: PropTypes.string.isRequired,
};

export default contractPage(RewardsRegulation, {
  routeKey: 'REWARDS_CONTRACT',
  googleDocumentId: '1LrfuyjJqQWT2DW81Lkyn2CeVNiwYt1455w5P3rk7tCI',
});
